import request from '@/utils/request'

export function getSellerInfo(data) {
  return request({
    url: '/seller/getsellerinfo',
    method: 'get',
    params:data
  })
}
